import React from 'react';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

export default function ErrorMsg({ text }) {
	const useStyles = makeStyles((theme) => ({
		textErr: {
			color: 'red'
		}
	}));

	const classes = useStyles();

	return (
		<Typography variant="h6" component="h6" className={classes.textErr}>
			{text}
		</Typography>
	);
}
